export default __webpack_public_path__ + "static/media/rubik-v12-latin-700.b1bad93c.svg";